import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';
import { format } from 'date-fns';

import { dateFormat } from 'constants/formats';

import EditButton from 'modules/_shared/components/Buttons/EditButton';
import { setModal } from 'modules/_shared/redux/modalActions';
import EditCommentsModal from 'modules/_shared/components/Modals/EditComments';
import { useGetTransactionsSectionPermissions } from 'modules/transactions/hooks/useGetTransactionsSectionPermissions';

import { useOperationDetailsPage } from '../context/OperationDetailsPageContext';
import { operationsWithoutNotarialRegistrationSection } from '../constants/operationsWithoutNotarialRegistrationSection';

const CommentsSection: FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const { data } = useOperationDetailsPage();
  const { isReadOnly } = useGetTransactionsSectionPermissions().data;

  const operationDate = data.operation?.date
    ? format(new Date(data.operation?.date), dateFormat)
    : '-';
  const operationType = data.operation?.operationType || '';
  const operationComments = data.operation?.comments || '';
  const hasNotarialRegistration =
    !operationsWithoutNotarialRegistrationSection.includes(operationType);

  return (
    <div className="invoice-contact col-4">
      <span className="overline-title">{t('TransactionType')}</span>

      <div className="invoice-contact-info">
        <h4 className="title">{t(operationType)}</h4>

        <ul className="list-plain">
          {operationComments && (
            <li>
              <span className="text-muted">
                <em className="icon ni ni-notes-alt" />
                {operationComments}
              </span>

              <EditButton
                className="ml-1 pb-1"
                action={() =>
                  dispatch(
                    setModal(
                      <EditCommentsModal
                        operation={data.operation}
                        hasNotarialRegistration={hasNotarialRegistration}
                      />
                    )
                  )
                }
                disabled={isReadOnly}
              />
            </li>
          )}
          <li>
            <span className="text-muted">
              <em className="icon ni ni-calender-date" />
              <span>{operationDate}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CommentsSection;
